import { render, staticRenderFns } from "./WorkflowSharePoliciesAccordion.vue?vue&type=template&id=1d59f606&scoped=true"
import script from "./WorkflowSharePoliciesAccordion.vue?vue&type=script&lang=js"
export * from "./WorkflowSharePoliciesAccordion.vue?vue&type=script&lang=js"
import style0 from "./WorkflowSharePoliciesAccordion.vue?vue&type=style&index=0&id=1d59f606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d59f606",
  null
  
)

export default component.exports